import React from 'react';
import { Button } from 'react-bootstrap';
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight, MdOutlineKeyboardDoubleArrowLeft, MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";

const ManualPagination = ({ currentPage, setCurrentPage, pageCount, currentRange = "0-0 of 0", rowsPerPage = 5, setRowsPerPage, transaction }) => {
    const handleNextPage = () => {
        if (currentPage < pageCount) {
            setCurrentPage(currentPage + 1);
        }
    };

    // move to the Previous page
    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    // reset the page to the first page 
    const moveToStart = () => {
        setCurrentPage(1);
    };

    // reset the page to the last page 
    const moveToEnd = () => {
        setCurrentPage(pageCount);
    };

    // Handle change in rows per page
    const handleRowsPerPageChange = (e) => {
        const newRowsPerPage = +e.target.value;
        if (transaction) {

            setRowsPerPage(newRowsPerPage);

        } else {
            setRowsPerPage(newRowsPerPage);
            // Adjust current page if necessary
            const newPageCount = Math.ceil(pageCount * rowsPerPage / newRowsPerPage);
            if (currentPage > newPageCount) {
                setCurrentPage(newPageCount);
            }

        }
    };

    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", margin: "10px 0px", gap: "12px" }}>
            {/* set to start Btn */}
            <Button onClick={moveToStart} disabled={currentPage === 1} style={{ padding: "3px", backgroundColor: "#fff" }}>
                <MdOutlineKeyboardDoubleArrowLeft color="#000" />
            </Button>
            {/* Previous page Btn */}
            <Button onClick={handlePrevPage} disabled={currentPage === 1} style={{ padding: "3px" }}>
                <MdOutlineKeyboardArrowLeft />
            </Button>
            {/* current range */}
            {currentRange && <span>{currentRange}</span>}
            {/* next page Btn */}
            <Button onClick={handleNextPage} disabled={currentPage === pageCount} style={{ padding: "3px" }}>
                <MdOutlineKeyboardArrowRight />
            </Button>
            {/* set to last Btn */}
            <Button onClick={moveToEnd} disabled={currentPage === pageCount} style={{ padding: "3px", backgroundColor: "#fff" }}>
                <MdOutlineKeyboardDoubleArrowRight color="#000" />
            </Button>
            {/* rows per each page select */}
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "9px" }}>
                <p className="m-0">Rows per page:</p>
                <select
                    value={rowsPerPage}
                    onChange={handleRowsPerPageChange}
                >
                    <option value="5">05</option>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                </select>
            </div>
        </div>
    );
};

export default ManualPagination;